import { render } from "./AllianceDashboard.vue?vue&type=template&id=477df62f&scoped=true"
import script from "./AllianceDashboard.vue?vue&type=script&lang=js"
export * from "./AllianceDashboard.vue?vue&type=script&lang=js"

import "./AllianceDashboard.vue?vue&type=style&index=0&id=477df62f&lang=scss&scoped=true"
import "./AllianceDashboard.vue?vue&type=style&index=1&id=477df62f&lang=css"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477df62f"]])

export default __exports__